import clsx from "classnames";
import { Container, Stack } from "react-bootstrap";
import { SiteFooterCopyright, SiteFooterDetails, SiteFooterNav, SiteFooterSocials } from "./__components";
import classes from "./styles.module.scss";
import PropTypes from "prop-types";
import { getRoute } from "@/functions/getRoute";
import { getGlobal } from "@/functions/getGlobal";
import { Image } from "@/ui";

export default function SiteFooter({ className }) {
  const global = getGlobal();
  const company_name = global["_theme.company.name"];
  const footer_bg = global["_theme.footer.bg"];

  return (
    <div className={clsx(className, classes.footer, "pt-5 pb-4")} style={{ backgroundImage: `url(${footer_bg})` }}>
      <Container>
        <hr />
      </Container>
      <Container>
        <SiteFooterNav className={clsx(classes.footer__nav, "flex-md-row mb-4")} />
      </Container>
      <Container>
        <hr />
      </Container>
      <Container className="text-center text-md-start">
        <Stack className="flex-lg-row justify-content-between align-items-center" gap={3}>
          <SiteFooterSocials
            className={clsx(classes.footer__socials, "justify-content-center justify-content-lg-start flex-grow-0")}
          />
          <SiteFooterDetails className={clsx(classes.footer__details, "flex-lg-row px-4")} />
          <a className={classes.footer__brand} href="https://www.apscoau.org/2024-award-winners" target="_blank">
            <Image img="/2024-finalists.png" size="212x73" alt={company_name} />
          </a>
          <a className={classes.footer__brand__smaller} href="https://www.apscoau.org/" target="_blank">
            <Image img="/apsco-logo.png" size="200x60" alt="APSCo" />
          </a>
          <a
            className={classes.footer__brand__smaller}
            href="https://onthewards.org/?utm_source=Medacs+Healthcare&utm_medium=Website&utm_campaign=Medacs_Healthcare_OTW_Logo&utm_id=Medacs+Healthcare+2022"
            target="_blank"
          >
            <Image img="/onthewards-logo.jpg" size="200x60" alt="OnTheWards" />
          </a>
          <a className={classes.footer__brand} href={getRoute("home")}>
            <Image img="/medacs-small-logo.png" size="212x73" alt={company_name} />
          </a>
        </Stack>
        <SiteFooterCopyright className={clsx(classes.footer__copyright, "flex-lg-row mt-5 small")} />
      </Container>
    </div>
  );
}

SiteFooter.defaultProps = {
  className: "",
};

SiteFooter.propTypes = {
  className: PropTypes.string,
};
